import { BaseComponent } from 'components/BaseComponent';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import React from 'react';
import { SelectCreditorModal } from '../../pages/create/AddVehicleModals/AddCreditorModal/SelectVehicleCreditorCompany';
import { selectNewVehicle, selectNewVehicleValue } from '../../selectors';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import { CompanyLabel } from '../../../Companies/components/CompanyLabel';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { VBox } from '../../../../components/Box';
import CheckboxComponent from '../../../../containers/App/Components/Checkbox/Checkbox';
import { copyVehicle } from '../../actions';
import { PusherChannel } from './PusherComponent';
import { Check } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';

const STATE = {
  showCreditorModal: true,
  copyOptionsModal: false,
  selectedSteps: [],
  steps: {},
  error: null,
  newVehicleId: null,
  finish: false,
  roomId: null,
  pusherLoader: false,
};

class CopyVehicleModalComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  handleCopyStatus(data) {
    this.setState({
      steps: data.steps || {},
      error: data.error,
      newVehicleId: data.newVehicleId,
      finish: data.finish,
    });
  }

  reset() {
    this.props.onClose();
  }

  onCreditorModalConfirm({ creditorCompany, creditor }) {
    this.setState({
      showCreditorModal: false,
      copyOptionsModal: true,
      creditorCompany,
      creditor,
    });
  }

  get availableSteps() {
    return ['DATA', 'PHOTOS', 'DOCUMENTS', 'INSPECTION', 'TASKS'];
  }

  handleCheck(evt) {
    const { name, checked } = evt.target;
    this.setState(prev => ({
      selectedSteps: checked ? [...prev.selectedSteps, name] : prev.selectedSteps.filter(step => step !== name),
    }));
  }

  checkAll() {
    this.setState({ selectedSteps: this.availableSteps });
  }

  uncheckAll() {
    this.setState({ selectedSteps: [] });
  }

  async copy() {
    this.setState({ pusherLoader: true });
    this.props.copyVehicle(
      {
        steps: this.state.selectedSteps,
        creditorCompany: this.state.creditorCompany?.id,
        creditor: this.state.creditor,

      },
      result => {
        if (result) {
          this.setState({ roomId: result });
        }
      },
    );
  }

  renderCopyOptionsModal() {
    const allStepsDone = Object.values(this.state.steps).every(status => status === 'done');
    const hasError = this.state.error !== null;
    const isCopyInProgress = Object.values(this.state.steps).some(
      status => status === 'in_progress' || status === 'pending',
    );

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('Copy vehicle')}>
        <div className="mb-3">
          <CompanyLabel company={this.state.creditorCompany} />
        </div>

        {this.state.roomId && (
          <PusherChannel
            roomId={this.state.roomId}
            onStatusUpdate={this.handleCopyStatus.bind(this)}
            onReady={() => this.setState({ pusherLoader: false })}
          />
        )}

        {this.state.pusherLoader && (
          <div className="d-flex justify-content-center my-4">
            <Loader />
          </div>
        )}

        {!this.state.pusherLoader && (
          <>
            {Object.keys(this.state.steps).length > 0 && (
              <div className="mb-3">
                {hasError ? (
                  <div className="alert alert-danger">{this.state.error}</div>
                ) : (
                  <div className="alert alert-info">
                    {this.lbl(allStepsDone ? 'vehicle.copy.copy_completed' : 'vehicle.copy.copy_in_progress')}
                    {allStepsDone && this.state.newVehicleId && (
                      <div className="mt-2">
                        <ButtonComponent
                          style="ButtonSoftPrimaryFullWidth"
                          onClick={() => {
                            this.to(`/vehicles/${this.state.newVehicleId}`);
                            this.reset();
                          }}
                        >
                          {this.lbl('vehicle.copy.view_new_vehicle')}
                        </ButtonComponent>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            <VBox left className="w-100">
              {this.availableSteps.map(step => (
                <div key={step} className="d-flex mb-2">
                  <CheckboxComponent
                    label={this.lbl(step.toLowerCase())}
                    name={step}
                    checked={this.state.selectedSteps.includes(step)}
                    onChange={this.handleCheck.bind(this)}
                    className={this.state.selectedSteps.includes(step) ? 'green' : undefined}
                    disabled={isCopyInProgress || this.state.finish}
                  />
                  {this.state.steps[step] && (
                    <div className="ms-2">
                      {['in_progress', 'pending'].includes(this.state.steps[step]) ? (
                        <Loader small />
                      ) : this.state.steps[step] === 'done' ? (
                        <Check className="text-success" />
                      ) : null}
                    </div>
                  )}
                </div>
              ))}
              <div className="d-flex justify-content-end gap-2">
                <ButtonComponent
                  style="ButtonSoftPrimary"
                  onClick={this.checkAll.bind(this)}
                  disabled={isCopyInProgress || this.state.finish}
                >
                  {this.lbl('vehicle.copy.check_all')}
                </ButtonComponent>
                <ButtonComponent
                  style="ButtonSoftPrimary"
                  onClick={this.uncheckAll.bind(this)}
                  disabled={isCopyInProgress || this.state.finish}
                >
                  {this.lbl('vehicle.copy.uncheck_all')}
                </ButtonComponent>
              </div>
            </VBox>

            <div className="d-flex justify-content-end gap-2">
              <ButtonComponent
                style="ButtonSoftPrimary"
                onClick={this.copy.bind(this)}
                disabled={
                  isCopyInProgress ||
                  this.state.finish ||
                  this.state.selectedSteps.length === 0 ||
                  !!this.state.roomId
                }
              >
                {this.lbl('copy')}
              </ButtonComponent>
              <ButtonComponent style="ButtonSoftDelete" onClick={this.reset.bind(this)} disabled={isCopyInProgress}>
                {this.lbl('close')}
              </ButtonComponent>
            </div>
          </>
        )}
      </ModalComponent>
    );
  }


  render() {
    if (this.state.showCreditorModal)
      return (
        <SelectCreditorModal
          reset={this.reset.bind(this)}
          onConfirm={this.onCreditorModalConfirm.bind(this)}
          defaultCreditor={this.props.defaultCreditor}
          defaultCreditorUser={this.props.defaultCreditorUser}
        />
      );

    if (this.state.copyOptionsModal) return this.renderCopyOptionsModal();
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    creditorCompany: selectNewVehicleValue('creditor_company'),
    creditor: selectNewVehicleValue('creditor'),
    values: selectNewVehicle(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    copyVehicle(dto, callback) {
      dispatch(copyVehicle(ownProps.vehicle.id, dto, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CopyVehicleModal = compose(withConnect, withRouter)(CopyVehicleModalComp);
